import { Injectable } from '@angular/core';
import { HubConnectionState } from '@microsoft/signalr';
import { F24ErroreImportazioneModel, F24ImportatiValidatiModel } from 'app/main/gestione-scadenze-folder/gestione-scadenze.models';
import { AuthenticationService } from 'app/modules-services/auth-services/authentication.service';
import { Observable } from 'rxjs';
import { map, tap } from 'rxjs/operators';
import { SignalrCoreServiceBase } from './signalr-core-service-base';

@Injectable({
    providedIn: 'root',
})
export class SignalrCoreService extends SignalrCoreServiceBase {
    f24Validati$: Observable<F24ImportatiValidatiModel>;
    f24ErroreImportazione$: Observable<string>;
    onJobWorkerProgress$: Observable<{ jobId: string; progressInfo: string; level: number }>;
    onRegistrazioneAggiornata$: Observable<{ utentiId: number }>;
    eventoControlloAggiornato$: Observable<{ eventoDiControlloId: number; rimpiazzatoDaId?: number }>;

    constructor(private authService: AuthenticationService) {
        super();

        this.authService.isAuthenticated$.subscribe(isAuthenthicated => {
            console.warn('Signnalr authentication changed, is authenticated?', isAuthenthicated);

            if (isAuthenthicated === true) {
                // Avoid calling start() on a connection that is already connecting/connected
                // (e.g. when a token refresh re-emits authData$): SignalR rejects start() then.
                if (this.hubConnection && this.hubConnection.state !== HubConnectionState.Disconnected) {
                    return;
                }
                this.startConnection();
            } else {
                if (this.hubConnection && this.hubConnection.state == HubConnectionState.Connected) {
                    this.hubConnection.stop();
                }
            }
        });
    }

    /**
     * SignalR accessTokenFactory reads this on every negotiate/reconnect, so it must return the
     * live token instead of the cached jwtToken (which is refreshed in the background).
     */
    protected getAccessToken(): string | null {
        return this.authService.getAccessToken();
    }

    /**
     * Delegates to AuthenticationService.handleTokenRefresh(), reusing its single-flight
     * coordination so SignalR and the rest of the app share one refresh request.
     */
    protected refreshToken(): Observable<string> {
        return this.authService.handleTokenRefresh();
    }

    public buildConnection() {
        if (this.hubConnection) {
            return this;
        }
        super.buildConnection();

        this.f24Validati$ = this.subscribeMessage<F24ImportatiValidatiModel>('onF24Validati').asObservable();
        this.f24ErroreImportazione$ = this.subscribeMessage<F24ErroreImportazioneModel>('onF24ErroreImportazione').pipe(map(x => x.errore));
        this.onJobWorkerProgress$ = this.subscribeMessage<{ jobId: string; progressInfo: string; level: number }>('onJobWorkerProgress').asObservable();
        this.onRegistrazioneAggiornata$ = this.subscribeMessage<{ utentiId: number }>('onRegistrazioneAggiornata').asObservable();
        this.eventoControlloAggiornato$ = this.subscribeMessage<{ eventoDiControlloId: number; rimpiazzatoDaId?: number }>(
            'onEventoDiControlloAggiornato'
        ).asObservable();
        return this;
    }

    public startConnection() {
        this.buildConnection();
        super.startConnection();
    }
}
